import { config } from './config';

// Left-hand brand/marketing panel — mirrors the wp-login "student access"
// design language (90/90 system, subject tiles). Hidden on narrow screens.
// Eyebrow + subject tiles come from the injected program config (A Level or
// O Level / IGCSE).
export function BrandPanel() {
    return (
        <aside className="aft-panel">
            <div className="aft-panel-inner">
                {config.logoUrl ? (
                    <img src={config.logoUrl} alt={config.schoolName} className="aft-logo" />
                ) : (
                    <span className="aft-logo-text">{config.schoolName}</span>
                )}

                <p className="aft-eyebrow">{config.eyebrow}</p>
                <p className="aft-ninety">90&times;90</p>
                <div className="aft-rule" aria-hidden="true" />
                <p className="aft-copy">
                    Ninety lessons of ninety minutes &mdash; the whole syllabus, mastered. Not a video
                    library. A path with a finish line.
                </p>

                <div className="aft-subjects">
                    <p className="aft-eyebrow aft-eyebrow-muted">{config.tiles.length} subjects</p>
                    <div className="aft-tiles">
                        {config.tiles.map((tile) => (
                            <span
                                key={tile.abbr + tile.title}
                                className="aft-tile"
                                style={{ ['--sc' as string]: tile.color }}
                                title={tile.title}
                            >
                                {tile.abbr}
                            </span>
                        ))}
                    </div>
                    <p className="aft-caption">Sciences, commerce and humanities · one path each</p>
                </div>
            </div>
        </aside>
    );
}
